// extracted by mini-css-extract-plugin
module.exports = {"card":"HudCard_card__2joM4","header":"HudCard_header__V6sal","title":"HudCard_title__Yw1yO"};